import { portableProviderDefinitions } from '@proj-airi/provider-inference'

import { registerProviders } from './registry'

import './aliyun-nls'
import './apple-speech'
import './apple-vision'
import './sherpaw'
import './local-audio'
import './kokoro-local'
import './sherpa-kokoro'
import './character-voice'
import './nvidia'
import './prompt-api'

registerProviders(portableProviderDefinitions)

export {
  OFFICIAL_TRANSCRIPTION_PROVIDER_ID,
} from './official'

export {
  getDefinedProvider,
  isProviderId,
  listProviders,
  registerProviders,
} from './registry'

export type { StageProviderId } from './registry'
